import template from './banktx-bulk.html';
import controller from './banktx-bulk.controller';

let banktxBulkComponent = {
    restrict: 'E',
    bindings: {},
    template,
    controller
};

export default banktxBulkComponent;
